import React from "react";
import { Snackbar } from "@mui/material";
import { useMattoState } from "../../MattoState";

export const ProjectsSnackbarComponent = () => {
    const snackbarMessage = useMattoState((state) => state.snackbarMessage) as string | null;;
    const snackbarAutoHide = useMattoState((state) => state.snackbarAutoHide);
    const setSnackbarMessage = useMattoState((state) => state.setSnackbarMessage);
    return (
        <Snackbar 
            open={snackbarMessage != null && snackbarMessage.length > 2} 
            onClose={ () => { setSnackbarMessage(null) } } 
            ClickAwayListenerProps={{ onClickAway: () => null }}
            // autoHideDuration={3500}
            autoHideDuration={snackbarAutoHide ? 3500 : null}
            message={snackbarMessage} />
    );
}